import { render, staticRenderFns } from "./picdescdialog.vue?vue&type=template&id=3760113b&scoped=true&"
import script from "./picdescdialog.vue?vue&type=script&lang=js&"
export * from "./picdescdialog.vue?vue&type=script&lang=js&"
import style0 from "./picdescdialog.vue?vue&type=style&index=0&id=3760113b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3760113b",
  null
  
)

export default component.exports